import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projectsList: {
    paginated_results: [],
    not_filtered_projects: [],
    counters: {
      total_projects: 0,
      total_new_projects: 0,
      total_in_progress_projects: 0,
      total_pending_projects: 0,
      total_completed_projects: 0,
      total_refunded_projects: 0,
      total_failed_projects: 0,
    },
    pagination: {
      active_page: 1,
      total_pages: 1,
      items_per_page: 10,
    },
    filter_options: {
      brand: [],
      model: [],
      vehicle_type: [],
      project_status: [],
      created_at: [],
      modified_at: [],
    },
  },
  currentProjectId: null,
};

export const projectsSlice = createSlice({
  name: "projects",
  initialState: initialState,
  reducers: {
    getProjects: (state, action) => {
      state.projectsList = action.payload;
    },
    getCurrentProjectId: (state, action) => {
      state.currentProjectId = action.payload;
    },
    changePageNumberProjects: (state, action) => {
      state.projectsList.pagination.active_page = action.payload;
    },
  },
});

export const selectProjectsList = (state) => state.project.projectsList;
export const selectUserProjects = (state) => state.project.projectsList;
export const selectSingleProject = (state) => {
  const projectId = Number(state?.project?.currentProjectId);
  return state?.project?.projectsList?.paginated_results?.find(
    (proj) => proj.id === projectId
  );
};
export const { getProjects, changePageNumberProjects, getCurrentProjectId } =
  projectsSlice.actions;
export default projectsSlice.reducer;
